import Repository from '../../repositories/RepositoryFactory';
const ccmVitalEntryRepository = Repository.get('ccmVitalEntry');

export default {
	namespaced: true,
	state: {
		ccmVitalEntriesByPatientId: [],
		ccmVitalEntriesByCCMRecordId: [],
		ccmVitalEntry: null,
		ccmVitalEntriesLoadingStatus: false,
	},
	mutations: {
		STORE_CCM_VITAL_ENTRIES_BY_PATIENT_ID (state, payload) {
			state.ccmVitalEntriesByPatientId = payload;
		},

		ADD_CCM_VITAL_ENTRY_IN_PATIENT_LIST (state, payload) {
			state.ccmVitalEntriesByPatientId.unshift(payload);
		},

		STORE_CCM_VITAL_ENTRIES_BY_CCM_RECORD_ID (state, payload) {
			state.ccmVitalEntriesByCCMRecordId = payload;
		},

		STORE_CCM_VITAL_ENTRY (state, payload) {
			state.ccmVitalEntry = payload;
		},

		UPDATE_CCM_VITAL_ENTRY (state, payload) {
			state.ccmVitalEntry = {
				...state.ccmVitalEntry,
				...payload,
			};
		},

		UPDATE_CCM_VITAL_ENTRY_IN_PATIENT_LIST (state, payload) {
			const index = state.ccmVitalEntriesByPatientId.findIndex((entry) => entry.id === payload.id);
			if (index !== -1) {
				state.ccmVitalEntriesByPatientId.splice(index, 1, payload);
			}
		},

		TOGGLE_CCM_VITAL_ENTRY_LOADING_STATUS (state, payload) {
			state.ccmVitalEntriesLoadingStatus = payload;
		},

		REMOVE_CCM_VITAL_ENTRY (state, id) {
			state.ccmVitalEntriesByPatientId = state.ccmVitalEntriesByPatientId.filter((record) => record.id !== id);
		},
	},
	actions: {
		async getCCMVitalEntriesByPatientId ({ commit }, patientId) {
			commit('TOGGLE_CCM_VITAL_ENTRY_LOADING_STATUS', true);
			const response = await ccmVitalEntryRepository.getCCMVitalEntriesByPatientId(patientId);
			commit('STORE_CCM_VITAL_ENTRIES_BY_PATIENT_ID', response.data);
			commit('TOGGLE_CCM_VITAL_ENTRY_LOADING_STATUS', false);
		},
		async getCCMVitalEntriesByPatientIdByMonthByYear ({ commit }, data) {
			const { patientId, month, year } = data;
			const response = await ccmVitalEntryRepository.getCCMVitalEntriesByPatientIdByMonthByYear(patientId, month, year);
			return response;
		},
		async getCCMVitalEntriesByCCMRecordId ({ commit }, ccmRecordId) {
			const response = await ccmVitalEntryRepository.getCCMVitalEntriesByCCMRecordId(ccmRecordId);
			commit('STORE_CCM_VITAL_ENTRIES_BY_CCM_RECORD_ID', response.data);
		},
		async getCCMVitalEntryById ({ commit }, id) {
			const response = await ccmVitalEntryRepository.getCCMVitalEntryById(id);
			commit('STORE_CCM_VITAL_ENTRY', response.data);
		},
		async addCCMVitalEntry ({ commit }, body) {
			const response = await ccmVitalEntryRepository.addCCMVitalEntry(body);
			commit('ADD_CCM_VITAL_ENTRY_IN_PATIENT_LIST', response.data);
			return response;
		},
		async updateCCMVitalEntry ({ commit }, request) {
			const response = await ccmVitalEntryRepository.updateCCMVitalEntry(request.id, request.body);
			commit('UPDATE_CCM_VITAL_ENTRY_IN_PATIENT_LIST', response.data);
			return response;
		},
		async deleteCCMVitalEntry ({ commit }, id) {
			commit('REMOVE_CCM_VITAL_ENTRY', id);
			return await ccmVitalEntryRepository.deleteCCMVitalEntry(id);
		},
		async disableMedicalNoteForThisVitalEntry ({ commit }, id) {
			return await ccmVitalEntryRepository.disableMedicalNoteForThisVitalEntry(id);
		},
	},
};
